import { init } from "@eppo/js-client-sdk";
import { useMutation } from "@faire/web-api--source/endpoints/www/api/v2/setting/record_raw_assignment/post-hooks";
import { IRecordRawAssignmentsRequest } from "@faire/web-api--source/faire/settings_boss/IRecordRawAssignmentsRequest";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import React, { ReactElement, useEffect, useState } from "react";

interface IEppoRandomizationProvider {
  waitForInitialization?: boolean;
  children: ReactElement;
  loadingComponent?: ReactElement;
}

const EppoRandomizationProvider = ({
  waitForInitialization = true,
  children,
}: IEppoRandomizationProvider): ReactElement => {
  const [isInitialized, setIsInitialized] = useState(false);

  const recordAssignmentMutation = useMutation();

  useEffect(() => {
    const apiKey = getGlobalProperty<string>("eppoClientToken");

    if (!apiKey) {
      return;
    }
    void init({
      apiKey,
      assignmentLogger: {
        logAssignment(assignment) {
          const rawAssignment: IRecordRawAssignmentsRequest.IRawAssignment =
            IRecordRawAssignmentsRequest.IRawAssignment.build({
              identifier: assignment.subject,
              setting_name: assignment.featureFlag ?? "",
              experiment_name: assignment.experiment ?? "",
              bucket_name: assignment.variation ?? "",
              created_at: Date.now(),
              is_pretest: false,
            });
          const request: IRecordRawAssignmentsRequest = {
            assignments: [rawAssignment],
          };
          recordAssignmentMutation.mutate([request]);
        },
      },
    }).then(() => {
      setIsInitialized(true);
    });
  }, [recordAssignmentMutation]);

  if (!waitForInitialization || isInitialized) {
    return children;
  }
  return <></>;
};

export default EppoRandomizationProvider;
